import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import {
	ClientPortalLink,
	Contract,
	ContractPayload,
	ServerDataResponse
} from '@models/models';

@Injectable()
export class ContractsDataProvider {
	editableContract: BehaviorSubject<any> = new BehaviorSubject(false);
	contractTextUpdate: Subject<any> = new Subject();

	constructor(private http: HttpClient) {}

	get editableContractObservable(): Observable<any> {
		return this.editableContract.asObservable();
	}

	get shouldContractBeUpdatedObservable(): Observable<any> {
		return this.contractTextUpdate.asObservable();
	}

	emitContractToEdit(contract: Contract): void {
		this.editableContract.next(contract);
	}

	emitContractUpdateEvent(value?: Contract): void {
		this.contractTextUpdate.next(value);
	}

	getContract(jobId: number, jobContractId: number): Observable<any> {
		const url = `/protected/rest/contracts/get/view/${jobId}/${jobContractId}`;
		return this.http.get(url);
	}

	sendContractEmail(data, isNew: boolean): Observable<any> {
		const url = isNew
			? '/protected/rest/job/contract/save/'
			: '/protected/rest/job/contract/send';

		const { sendMessageData, storedFiles, uploadedFiles } = data;

		const formData: FormData = new FormData();

		for (const key in sendMessageData) {
			if (key !== 'attachmentsData') {
				formData.append(key, sendMessageData[key]);
			}
		}

		for (const key in storedFiles) {
			formData.append(`storedAttachments[${key}]`, storedFiles[key].id);
		}

		for (const key in uploadedFiles) {
			formData.append(`attachments[${key}]`, uploadedFiles[key]);
		}

		return this.sendContractRequest(url, formData);
	}

	sendContractRequest(url: string, formData: FormData): Observable<Object> {
		return this.http.post(url, formData);
	}

	deleteContract(id): Observable<any> {
		const url = `/protected/rest/contracts/view/delete/${id}`;
		return this.http.post(url, {});
	}

	addPhotographerSignature(data): Observable<any> {
		const url = '/protected/rest/contract/photographer/signature';
		return this.http.post(url, data);
	}

	editContract(url: string, data: object): Observable<Object> {
		return this.http.put(url, data);
	}

	getContractCpLink(
		url: string,
		method: string
	): Observable<ServerDataResponse<ClientPortalLink>> {
		return this.http[method.toLowerCase()](url);
	}

	overwriteContractTemplate(
		templateId: string,
		data: ContractPayload
	): Observable<ServerDataResponse<Contract>> {
		const url = `/api/user/contract-template/${templateId}`;
		return this.http.put(url, { data }) as Observable<
			ServerDataResponse<Contract>
		>;
	}

	saveNewContractTemplate(
		data: ContractPayload
	): Observable<ServerDataResponse<Contract>> {
		const url = '/api/user/contract-template';
		return this.http.post(url, { data }) as Observable<
			ServerDataResponse<Contract>
		>;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/contract/contracts.data.service.ts